import { render, staticRenderFns } from "./Lista-Pazienti.vue?vue&type=template&id=44540f40&scoped=true&"
import script from "./Lista-Pazienti.vue?vue&type=script&lang=js&"
export * from "./Lista-Pazienti.vue?vue&type=script&lang=js&"
import style0 from "./Lista-Pazienti.vue?vue&type=style&index=0&id=44540f40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44540f40",
  null
  
)

export default component.exports